"use strict";
const createSearchStringQuery = search => ({
    or: [
        { '$copackAgreement.name$': { iLike: `%${search.replace(' ', '%')}%` } },
        {
            '$orderBrokerageAgreement.name$': {
                iLike: `%${search.replace(' ', '%')}%`,
            },
        },
        {
            'entity.orderNumber': search,
        },
        {
            'entity.complaintNumber': search,
        },
    ],
});
module.exports = createSearchStringQuery;
